(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestingDeleteController', BatteryTestingDeleteController);

    BatteryTestingDeleteController.$inject = ['$uibModalInstance', 'entity', 'BatteryTestingService'];

    function BatteryTestingDeleteController($uibModalInstance, entity, BatteryTestingService) {
        var vm = this;
        vm.haqBatteryId = entity ? entity.id : null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.isDeleting = false;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            if (!vm.haqBatteryId) {
                return;
            }
            vm.isDeleting = true;
            BatteryTestingService.deleteBatteryTesting(vm.haqBatteryId)
                .then(function (res) {
                    $uibModalInstance.close(true);
                })
                .catch(function (error) {
                    console.error("Failed to delete Battery Testing:", error);
                })
                .finally(function () {
                    vm.isDeleting = false;
                });
        }
    }
})();
